import { Columns, Column, Box, Stack } from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import SellingABusinessSvg from 'src/images/SellingABusiness.svg';

import FindOutMore from '../FindOutMore/FindOutMore';
import SellingMessage from '../SellingMessage/SellingMessage';

const MobileMessage = () => (
  <Stack space="medium">
    <Columns space="large">
      <Column width="2/3">
        <SellingMessage>
          <FindOutMore />
        </SellingMessage>
      </Column>

      <Column width="1/3">
        <Box justifyContent="center" display="flex">
          <CustomSvg svg={SellingABusinessSvg} width={150} />
        </Box>
      </Column>
    </Columns>
  </Stack>
);

export default MobileMessage;
